import { apolloClient } from "@/plugins/vue-apollo.js";

const changeLandlordStatus = (_variables) => {
  // , limit, skip
  let responseFromApi;
  let variables = _variables;

  responseFromApi = apolloClient
    .mutate({
      mutation: require("@/landlord/api/mutations/change_landlord_status.graphql"),
      variables: variables,
      update: (store, { data }) => {
        const query = {
          query: require("@/landlord/api/queries/landlord_query.graphql"),
          variables: {
            input: {
              limit: 10,
              skip: 0
            },
            filter: {
              searchKey: ''
            }
          }
        };
        let allLandlord = store.readQuery(query);
        store.writeQuery({
          ...query,
          data: allLandlord,
          status: data
        });
      }
    })
    .catch(error => {
      return error;
    });
  return responseFromApi;
};
export { changeLandlordStatus };
